import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

// Sits in a dialog's action bar to flag edits that won't be kept unless the
// user saves. Takes the leading space so the buttons stay on the right.
export default function UnsavedChangesNotice({
    message = "You have unsaved changes",
}) {
    return (
        <Box
            role="status"
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.75,
                mr: "auto",
                minWidth: 0,
                color: "warning.dark",
            }}
        >
            <ErrorOutlineIcon fontSize="small" sx={{ flexShrink: 0 }} />
            <Typography variant="body2" sx={{ fontWeight: 700 }}>
                {message}
            </Typography>
        </Box>
    );
}
